// @flow

import React, {Component} from 'react';
import type {Element} from 'react';
import AnimateHeight from 'react-animate-height';
import {connector} from '../store';
import ScheduledEpisode from './ScheduledEpisode.jsx';

import ga from '../../../vendor/google-analytics';

export class Airings extends Component<*, *> {
  state: {
    height: number
  };

  constructor(props: *) {
    super(props);

    this.state = {
      height: 0
    };
  }

  componentWillReceiveProps(nextProps: *) {
    let willHaveEpisodeAirings = nextProps.schedule.displayAll && nextProps.show.episodeAirings.length > 0;

    setTimeout(() => {
      this.setState({height: willHaveEpisodeAirings && nextProps.schedule.displayAll ? 'auto' : 0});
    }, 50);
  }

  render() {
    let allHandler = () => {

      // Only track when opening
      if (!this.props.schedule.displayAll) {
        ga('send', 'event', 'Show | Schedule', 'Display All | [P]', this.props.show.title);
      }

      this.props.toggleAirdates(!this.props.schedule.displayAll)
    };

    return (
      <div className="show-schedule full-row">
        <div className="row">
          <div className="small-12 columns">
            <div className="show-airdates">
              <div className="show-airdates-header section-header headline">Broadcast Dates</div>
              <div className="channel-schedule-wrapper">
                {this.props.show.airings.length === 0 && <div>This show is not scheduled to air soon.</div>}
                {this.props.show.airings.length > 0 && <ul className="channel-schedule">
                  {this.props.show.airings.map((airing) =>
                    <li key={airing.id} className="airing">
                        <span className="airing-title">
                          #{airing.number} - {airing.title}
                          <span className="show-for-large-up"> | </span>
                          {airing.isNew && <span className="highlight-text"> New</span>}
                        </span>
                      <br className="show-for-medium-down"/>
                      <span className="airing-time"> {airing.displayTime}</span>
                      <a href="/channels" className="no-delay airing-channel"> {airing.channel} </a>
                    </li>
                  )}
                </ul>}
              </div>
            </div>
          </div>
        </div>
        <AnimateHeight
          className="inner-page-content row"
          duration={500}
          height={this.state.height}>
          <div className="row">
            <div className="small-12 columns">
              <div className="show-airdates">
                <ul className="channel-schedule">
                  {this.props.show.episodeAirings.map(ScheduledEpisode)}
                </ul>
              </div>
            </div>
          </div>
        </AnimateHeight>
        {this.props.show.airings.length > 0 &&
        <div className="call-to-action-row row">
          <div className="call-to-action-divider"></div>
          <button className="call-to-action call-to-action-btn loadmore-videos" onClick={allHandler}>
            {this.state.height === 0 ? 'Show All Air Dates' : 'Close'}
          </button>
        </div>}
      </div>
    );
  }
}

export default connector(Airings);